enum EventChannels {
    GAME = 'game',
    LEADERBOARDS = 'leaderboards',
    PLAYER = 'player',
    SCORE = 'score'
}

export default EventChannels;